import request from '@/router/axios';

function toBladePageParams(params) {
  const p = { ...(params || {}) };
  if (p.page != null) {
    p.current = p.page;
    delete p.page;
  }
  return p;
}

export const getList = (params) => {
  return request({
    url: '/api/produce/contract-pay-whitelist/page',
    method: 'get',
    params: toBladePageParams(params),
  });
};

export const add = (row) => {
  return request({
    url: '/api/produce/contract-pay-whitelist/add',
    method: 'post',
    data: row,
  });
};

export const update = (row) => {
  return request({
    url: '/api/produce/contract-pay-whitelist/update',
    method: 'post',
    data: row,
  });
};

export const updateStatus = (row) => {
  return request({
    url: '/api/produce/contract-pay-whitelist/update-status',
    method: 'post',
    data: row,
  });
};

export const remove = (row) => {
  const data = row && typeof row === 'object' ? row : { id: row };
  return request({
    url: '/api/produce/contract-pay-whitelist/remove',
    method: 'post',
    data,
  });
};

export const exportExcel = (params) => {
  return request({
    url: '/api/produce/contract-pay-whitelist/export',
    method: 'post',
    data: params,
    responseType: 'blob',
  });
};

export const selectTransportContracts = (params) => {
  return request({
    url: '/api/produce/transport-contract/select/page',
    method: 'get',
    params,
  });
};
